__turbopack_context__.v({
  "blink": "Gallery-module-scss-module__3R8-jW__blink",
  "closeGallery": "Gallery-module-scss-module__3R8-jW__closeGallery",
  "gallery": "Gallery-module-scss-module__3R8-jW__gallery",
  "galleryFooter": "Gallery-module-scss-module__3R8-jW__galleryFooter",
  "galleryOverview": "Gallery-module-scss-module__3R8-jW__galleryOverview",
  "gallerySwipper": "Gallery-module-scss-module__3R8-jW__gallerySwipper",
  "imageCounter": "Gallery-module-scss-module__3R8-jW__imageCounter",
  "overviewButton": "Gallery-module-scss-module__3R8-jW__overviewButton",
  "swiperSlide": "Gallery-module-scss-module__3R8-jW__swiperSlide",
  "title": "Gallery-module-scss-module__3R8-jW__title",
});
